import moment from 'moment';
import { Parser } from 'html-to-react';
import BaseAPI, { CacheOption as CacheOption_ } from '../data/base-api';
import { DateDisplayFormats } from './enum';
import LINKS from './links';

export const getInternetExplorerVersion = () => {
  let rv = -1;
  const { appName, userAgent, } = navigator;
  let regExpression;
  try {
    if (appName === 'Microsoft Internet Explorer') {
      regExpression = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
      if (regExpression.exec(userAgent)) {
        rv = parseFloat(RegExp.$1);
      }
    } else if (appName === 'Netscape') {
      regExpression = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
      if (regExpression.exec(userAgent) != null) {
        rv = parseFloat(RegExp.$1);
      }
    }
    return rv;
  } catch (ex) {
    rv = -1;
  }
  return rv;
};

export const goToIENotSupported = (props) => {
  const { history, } = props;
  return history.push(LINKS.IE_NOT_SUPPORTED);
};

export const goTo404 = (props) => {
  const { history, } = props;
  return history.push(LINKS.PAGE_MISSING);
};

export const formatDate = (date: Date | string, displayFormat: DateDisplayFormats = DateDisplayFormats.MonthDayYear): string => {
  return date ? moment(date)?.format(displayFormat) : '';
};

export const htmlParser = (encodedStr: string) => {
  const parser = Parser();

  return parser.parse(encodedStr);
};

export const buildRequestOptions = (path: string) => {
  return {
    url: `${window.BASE_URL}${path}`,
    headers: BaseAPI.getRequestHeaders(),
  };
};

export const isNullOrUndefined = (value) => {
  return `${value}` === 'null' || `${value}` === 'undefined';
};

export const isNullOrWhiteSpace = (value) => {
  return isNullOrUndefined(value) || `${value}`.trim() === '';
};

export const joinValidElementsInString = (elements = [], separator = '') => elements.filter(element => !isNullOrUndefined(element)).join(separator);

export const buildKeyForSessionStorage = ({ category, categoryName, }: CacheOption_) => joinValidElementsInString([category, categoryName], '-');

export const camelCaseSpacing = (ccStr) => ccStr.replace(/([a-z])([A-Z])/g, '$1 $2');
